import { render } from "./App.vue?vue&type=template&id=928e0b80"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=928e0b80&lang=scss"

import exportComponent from "E:\\jev-router\\runs\\dating-services-20261022\\build-workspace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__